document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 749) return;

  const blocks = document.querySelectorAll("footer .footer__block--links");
  console.log("[FooterAcc] blocks:", blocks.length);

  blocks.forEach(block => {
    const title = block.querySelector("p.h6");
    const list = block.querySelector("ul");
    if (!title || !list) return;

    block.classList.remove("is-open");
    title.addEventListener("click", () => {
      block.classList.toggle("is-open");
    });
  });
});